"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lit_html_1 = require("lit-html");
var ProfileView_1 = require("./ProfileView");
var solid_ui_1 = require("solid-ui");
var qrcode = require("qrcode");
function loadExtendedProfile(store, subject) {
    return __awaiter(this, void 0, void 0, function () {
        var otherProfiles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    otherProfiles = store.each(subject, solid_ui_1.ns.rdfs("seeAlso"), null, subject.doc());
                    if (!(otherProfiles.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, store.fetcher.load(otherProfiles)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
var Pane = {
    global: false,
    icon: solid_ui_1.icons.iconBase + "noun_15059.svg",
    name: "profile",
    label: function (subject, context) {
        var t = context.session.store.findTypeURIs(subject);
        if (t[solid_ui_1.ns.vcard("Individual").uri] ||
            t[solid_ui_1.ns.foaf("Person").uri] ||
            t[solid_ui_1.ns.schema("Person").uri]) {
            return "Profile";
        }
        return null;
    },
    render: function (subject, context) {
        var target = context.dom.createElement("div");
        var store = context.session.store;
        loadExtendedProfile(store, subject).then(function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, QRCodeEles, _loop_1, _i, _b, QRCodeElement, state_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = lit_html_1.render;
                        return [4 /*yield*/, (0, ProfileView_1.ProfileView)(subject, context)];
                    case 1:
                        _a.apply(void 0, [_c.sent(), target]);
                        QRCodeEles = Array.from(target.getElementsByClassName('QRCode')) // was context.dom
                        ;
                        if (!QRCodeEles.length)
                            return [2 /*return*/, console.error("QRCode Ele missing")];
                        _loop_1 = function (QRCodeElement) {
                            var value = QRCodeElement.getAttribute('data-value');
                            if (!value)
                                return { value: console.error("QRCode data-value missing") };
                            var highlightColor = QRCodeElement.getAttribute('highlightColor') || '#000000';
                            var backgroundColor = QRCodeElement.getAttribute('backgroundColor') || '#ffffff';
                            // console.log(`@@ qrcodes2 colours highlightColor ${highlightColor}, backgroundColor ${backgroundColor}`)
                            var options = {
                                type: 'svg',
                                color: {
                                    dark: highlightColor,
                                    light: backgroundColor
                                }
                            };
                            qrcode.toString(value, options, function (error, svg) {
                                if (error) {
                                    console.error('QRcode error!', error);
                                }
                                else {
                                    // console.log('QRcode success.', svg);
                                    QRCodeElement.innerHTML = svg;
                                    QRCodeElement.style.width = "80%";
                                    QRCodeElement.style.height = "80%";
                                    QRCodeElement.style.margin = "10%";
                                }
                            });
                        };
                        for (_i = 0, _b = QRCodeEles; _i < _b.length; _i++) {
                            QRCodeElement = _b[_i];
                            state_1 = _loop_1(QRCodeElement);
                            if (typeof state_1 === "object")
                                return [2 /*return*/, state_1.value];
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        return target;
    },
};
exports.default = Pane;
//# sourceMappingURL=index.js.map